// Cliente de Supabase para la aplicación Amarsi Control Panel
// Configura la conexión con el backend de Supabase para autenticación y base de datos

import { createClient } from '@supabase/supabase-js';

// Configuración de Supabase desde variables de entorno
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validación de configuración requerida
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Faltan las variables de entorno de Supabase. Revisa REACT_APP_SUPABASE_URL y REACT_APP_SUPABASE_ANON_KEY');
}

// Creación y exportación del cliente de Supabase
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true, // Mantiene la sesión activa al recargar la página
    autoRefreshToken: true, // Activamos auto-refresh para manejo automático de tokens
    detectSessionInUrl: true, // Detecta sesión desde URL (para magic links)
    // Configuración para reducir frecuencia de refresh
    refreshTokenThreshold: 1800, // 30 minutos antes de expiración
  },
});

// Exportación de tipos útiles para la aplicación
export { AuthError, AuthApiError } from '@supabase/supabase-js';

// Tipos adicionales para TypeScript (si se usan en el futuro)
// export type { Session, User } from '@supabase/supabase-js';
